import React from 'react';
import glamorous from 'glamorous';
import PropTypes from 'prop-types';
import SimpleButton from '../../../../../shared/library/buttons/base/simple';
import GhostButton from '../../../../../shared/library/buttons/base/ghost';
import {SIGN_IN_PATH} from '../../../../../shared/constants/paths';
import {FOCUS_BLUE} from '../../../../../shared/style/colors';
import {ALPHA} from '../../../../../shared/style/color-utils';

const StyledSimpleButton = glamorous(SimpleButton)({
  height: 34,
  fontSize: 13
});

const StyledGhostButton = glamorous(GhostButton)({
  color: FOCUS_BLUE,
  height: 'fit-content',
  width: 'fit-content',
  padding: 0,
  alignSelf: 'center',
  fontWeight: 600,
  ':hover': {
    color: ALPHA(FOCUS_BLUE, 0.8)
  }
});

const GET_ADVICE = 'getadvice';

const GetAdviceButton = ({
  userId,
  setOpenAdviceModal,
  setSignupAction,
  navigate,
  onClick,
  minimal
}) => {
  if (minimal) return <StyledGhostButton onClick={onClick}>Add Tool</StyledGhostButton>;

  return (
    <StyledSimpleButton
      onClick={() => {
        if (userId) {
          setOpenAdviceModal(true);
        } else {
          setSignupAction(GET_ADVICE);
          navigate(SIGN_IN_PATH);
        }
      }}
      width={120}
    >
      Get Advice
    </StyledSimpleButton>
  );
};

GetAdviceButton.propTypes = {
  userId: PropTypes.any,
  setOpenAdviceModal: PropTypes.func,
  setSignupAction: PropTypes.func,
  navigate: PropTypes.func,
  onClick: PropTypes.func,
  minimal: PropTypes.bool
};

export default GetAdviceButton;
